import { render, staticRenderFns } from "./SidebarNavLink.vue?vue&type=template&id=ec4cf136"
import script from "./SidebarNavLink.vue?vue&type=script&lang=js"
export * from "./SidebarNavLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports